import moment from 'moment';
import {es} from 'moment/locale/es';
import {dateFormatShow} from '../constants/datesFormat';

export const getMonthName = (monthId) => {
  if (monthId < 1 || monthId > 12) {
    return null;
  }
  moment.locale(es);
  const formattedMonth = moment().month(monthId - 1).format('MMMM');
  const monthNameCapitalized = formattedMonth.charAt(0).toUpperCase() + formattedMonth.substr(1);
      
  return monthNameCapitalized;
};

export const getMonthShortName = (monthId) => {
  if (monthId < 1 || monthId > 12) {
    return null;
  }
  moment.locale(es);
  const formattedMonth = moment().month(monthId - 1).format('MMM');
  const monthNameCapitalized = formattedMonth.charAt(0).toUpperCase() + formattedMonth.substr(1);
      
  return monthNameCapitalized.replace('.', '');
};

export const getLastDayOfMonth = (year, month) => {
  const date = moment().year(year).month(month).date(0);
  return parseInt(date.format('DD'), 10);
};

export const getDifferenceBetweenDates = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return null;
  }

  const initialDate = moment(startDate);
  const finalDate = moment(endDate);
  const duration = moment.duration(finalDate.diff(initialDate));
  return duration.asDays();
};

export const convertDateToSpecificFormat = (dateLikeString, format = dateFormatShow) => {
  if (!dateLikeString) {
    return null;
  }
  return moment(dateLikeString).format(format);
};
